"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandedContent = exports.ExpanderIcon = exports.ExpanderTitle = exports.EnabledWrapper = exports.DisabledWrapper = exports.Wrapper = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledComponentsRtl = _interopRequireDefault(require("styled-components-rtl"));
var _mediaGenerator = _interopRequireDefault(require("@berlitz/max-utils/lib/mediaGenerator"));
var _typography = require("@berlitz/globals/lib/components/typography");
var _templateObject;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Expanderstyle__Wrapper",
  componentId: "sc-13l00q6-0"
})(["width:100%;", ";"], function (_ref) {
  var theme = _ref.theme,
    isDisabled = _ref.isDisabled;
  return (0, _mediaGenerator.default)(theme, isDisabled, 'width: auto;');
});
exports.Wrapper = Wrapper;
var DisabledWrapper = _styledComponents.default.div.withConfig({
  displayName: "Expanderstyle__DisabledWrapper",
  componentId: "sc-13l00q6-1"
})(["display:none;visibility:hidden;", ";"], function (_ref2) {
  var theme = _ref2.theme,
    isDisabled = _ref2.isDisabled;
  return (0, _mediaGenerator.default)(theme, isDisabled, 'display: block; visibility: visible;');
});
exports.DisabledWrapper = DisabledWrapper;
var EnabledWrapper = _styledComponents.default.div.withConfig({
  displayName: "Expanderstyle__EnabledWrapper",
  componentId: "sc-13l00q6-2"
})(["display:block;border-bottom:", ";", ";"], function (_ref3) {
  var theme = _ref3.theme,
    border = _ref3.border;
  return border && theme.expander.borderBottom;
}, function (_ref4) {
  var theme = _ref4.theme,
    isDisabled = _ref4.isDisabled;
  return (0, _mediaGenerator.default)(theme, isDisabled, 'display: none;');
});
exports.EnabledWrapper = EnabledWrapper;
var ExpanderTitle = _styledComponents.default.button.withConfig({
  displayName: "Expanderstyle__ExpanderTitle",
  componentId: "sc-13l00q6-3"
})(["", ";padding:", ";cursor:pointer;width:100%;text-align:inherit;outline:none;margin:0 !important;@media (min-width:", "){&:focus{outline-color:-webkit-focus-ring-color;outline-style:auto;}}", ";", ";"], _typography.h5Style, function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.space.sm, " 0");
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.md;
}, function (_ref7) {
  var icon = _ref7.icon;
  return icon && (0, _styledComponents.css)(["display:flex;justify-content:space-between;align-items:center;"]);
}, function (_ref8) {
  var shrinkTitle = _ref8.shrinkTitle;
  return shrinkTitle && (0, _styledComponents.css)(["padding:0;padding-bottom:", ";width:auto;"], function (_ref9) {
    var theme = _ref9.theme;
    return theme.space.md;
  });
});
exports.ExpanderTitle = ExpanderTitle;
var ExpanderIcon = _styledComponents.default.span.withConfig({
  displayName: "Expanderstyle__ExpanderIcon",
  componentId: "sc-13l00q6-4"
})(["align-items:center;background-color:", ";padding:", ";border-radius:50%;display:flex;height:100%;", " transform:rotate(0deg);transition:all ", ";", ";"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.palette.blue10;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.space.sm;
}, (0, _styledComponentsRtl.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-right: ", ";\n  "])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.expander.iconMarginRight;
}), function (_ref13) {
  var theme = _ref13.theme;
  return theme.expander.transition;
}, function (_ref14) {
  var expanded = _ref14.expanded;
  return expanded && (0, _styledComponents.css)(["transform:rotate(-180deg);"]);
});
exports.ExpanderIcon = ExpanderIcon;
var ExpandedContent = _styledComponents.default.div.withConfig({
  displayName: "Expanderstyle__ExpandedContent",
  componentId: "sc-13l00q6-5"
})(["max-height:", ";overflow:", ";visibility:", ";opacity:", ";transition:opacity ", ";"], function (_ref15) {
  var expanded = _ref15.expanded;
  return expanded ? 'none' : '0px';
}, function (_ref16) {
  var expanded = _ref16.expanded;
  return expanded ? 'visible' : 'hidden';
}, function (_ref17) {
  var expanded = _ref17.expanded;
  return expanded ? 'visible' : 'hidden';
}, function (_ref18) {
  var expanded = _ref18.expanded;
  return expanded ? '1' : '0';
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.expander.transition;
});
exports.ExpandedContent = ExpandedContent;